"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = _interopRequireDefault(require("lodash"));
var _react = require("react");
var _useIsMounted2 = _interopRequireDefault(require("../../hooks/useIsMounted"));
;
var DEFAULT_EVENTS = ['mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mouseWheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove', 'visibilitychange'];
var IdleTimer = function IdleTimer(_ref) {
  var _ref$events = _ref.events,
    events = _ref$events === void 0 ? DEFAULT_EVENTS : _ref$events,
    onActive = _ref.onActive,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 1000 * 60 * 15 : _ref$timeout,
    onIdle = _ref.onIdle,
    delayedTimeout = _ref.delayedTimeout,
    onDelayedIdle = _ref.onDelayedIdle;
  var _useIsMounted = (0, _useIsMounted2.default)(),
    ifIsMounted = _useIsMounted.ifIsMounted; // ref to store the unix time stamp for the last event

  var lastEventAtRef = (0, _react.useRef)(Date.now()); // ref used to store setTimeout instance for idle

  var idleTimeoutInstance = (0, _react.useRef)(null); // ref to use within functions that rely on closure (setTimeout, event listener etc)

  var isIdleRef = (0, _react.useRef)(false); // state value for tracking whether or not the user is idle

  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isIdle = _useState2[0],
    setIsIdle = _useState2[1]; // used to track if the event listeners are currently registered

  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isListenersAdded = _useState4[0],
    setIsListenersAdded = _useState4[1]; // handler for idle (when the setTimeout function fires)

  var handleTimeout = function handleTimeout() {
    ifIsMounted(function () {
      setIsIdle(true);
    });
  }; // handler passed to event listeners

  var handleEvent = function handleEvent() {
    // store the previous lastEventAtValue
    var prevLastEventAt = lastEventAtRef.current; // update the lastEventAt value

    lastEventAtRef.current = Date.now(); //  compare the previous event time against the current time to ensure we havn't been "paused"
    //  (eg. inactive tab on safari+ios) longer than the timeout allows

    var elapsedMs = Date.now() - prevLastEventAt; // if we have been "paused" longer than the timeout should allow...

    if (!_lodash.default.isUndefined(delayedTimeout) && elapsedMs > delayedTimeout) {
      // call onDelayedLogout if its defined...
      if (!_lodash.default.isUndefined(onDelayedIdle)) {
        var elapsedSinceIdle = Math.floor(elapsedMs - delayedTimeout);
        onDelayedIdle(elapsedSinceIdle);
      } // set the user as idle

      if (!isIdleRef.current) {
        ifIsMounted(function () {
          setIsIdle(true);
        });
      }
      return;
    } // if we already have a timer, clear it

    if (idleTimeoutInstance.current !== null) {
      window.clearTimeout(idleTimeoutInstance.current);
      idleTimeoutInstance.current = null;
    } // create a new idle timer

    idleTimeoutInstance.current = window.setTimeout(handleTimeout, timeout); // if idle, set isIdle false, because an event has occurred

    if (isIdleRef.current) {
      ifIsMounted(function () {
        setIsIdle(false);
      });
    }
  }; // throttle handleEvent so that mouse movement (or other rapid events) doesn't overload us

  var throttledHandleEvent = _lodash.default.throttle(handleEvent, 200); // fn used to register event listeners

  var addListeners = function addListeners() {
    if (!isListenersAdded) {
      ifIsMounted(function () {
        events.forEach(function (event) {
          document.addEventListener(event, throttledHandleEvent, {
            // this listener gets events before the event target does
            capture: true,
            // we'll never call prevent default in here
            passive: true
          });
        });
        setIsListenersAdded(true);
      });
    }
  }; // fn used to unregister events

  var removeListeners = function removeListeners() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (isListenersAdded || force) {
      ifIsMounted(function () {
        events.forEach(function (event) {
          document.removeEventListener(event, throttledHandleEvent, {
            // this listener gets events before the event target does
            capture: true
          });
        });
        setIsListenersAdded(false);
      });
    }
  }; // on mount...

  (0, _react.useEffect)(function () {
    ifIsMounted(function () {
      idleTimeoutInstance.current = window.setTimeout(handleTimeout, timeout); // register the listeners

      addListeners();
    });
    return function () {
      removeListeners(true);
    };
  }, []); // when the idle state changes...

  (0, _react.useEffect)(function () {
    // only worry about isIdle changing once the component has mounted
    ifIsMounted(function () {
      // update the ref
      isIdleRef.current = isIdle;
      if (isIdle) {
        // if we've gone idle, call onIdle prop...
        onIdle();
      } else {
        // else we've gone active from being idle, so call onActive...
        if (onActive) onActive();
      }
    });
  }, [isIdle]);
  return null;
};
var _default = IdleTimer;
exports.default = _default;